module.exports = __webpack_public_path__ + "img/nordycki_ii.f444d327.jpg";